module.exports = __webpack_public_path__ + "static/media/download.b63d7e6e.svg";